import { render } from "./PhosphoriconsContent.vue?vue&type=template&id=a43cbe5c"
import script from "./PhosphoriconsContent.vue?vue&type=script&lang=js"
export * from "./PhosphoriconsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__